module.exports = __webpack_public_path__ + "img/analysisIcon4.6a5f23cf.png";